import {ItemsTreeResponse} from '@hconnect/uikit'
import {CardBox, VerticalNavigationTree} from '@hconnect/uikit/src/lib2'
import {Box, SxProps, Theme} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {TabTypeDto} from '../types'

type Props = {
  selectedTab?: TabTypeDto
  onTabChange: (tabType: string) => void
  cardBoxSx?: SxProps<Theme>
  selectedYear: number
}

const NAVIGATION_MENU_ALL_ID_VALUE = ''

export const SlaVerticalNavigationContainer: React.FC<Props> = ({
  selectedTab,
  onTabChange,
  cardBoxSx,
  selectedYear
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const formattedDate = selectedYear.toString()
  const noDataLabel = t('message.noData')

  const tree = {
    items: [
      {
        id: NAVIGATION_MENU_ALL_ID_VALUE,
        description: '',
        name: t('tabs.all'),
        order: 1,
        status: 0,
        children: [
          {
            id: TabTypeDto.ProcessEngineer,
            description: '',
            name: t(`tabs.${TabTypeDto.ProcessEngineer}`),
            order: 2,
            status: 0,
            children: []
          },
          {
            id: TabTypeDto.QualityEngineer,
            description: '',
            name: t(`tabs.${TabTypeDto.QualityEngineer}`),
            order: 3,
            status: 0,
            children: []
          },
          {
            id: TabTypeDto.ReliabilityEngineer,
            description: '',
            name: t(`tabs.${TabTypeDto.ReliabilityEngineer}`),
            order: 4,
            status: 0,
            children: []
          },
          {
            id: TabTypeDto.SystemsEngineer,
            description: '',
            name: t(`tabs.${TabTypeDto.SystemsEngineer}`),
            order: 5,
            status: 0,
            children: []
          },
          {
            id: TabTypeDto.OutagePlanning,
            description: '',
            name: t(`tabs.${TabTypeDto.OutagePlanning}`),
            order: 6,
            status: 0,
            children: []
          },
          {
            id: TabTypeDto.OptimizationSpecialist,
            description: '',
            name: t(`tabs.${TabTypeDto.OptimizationSpecialist}`),
            order: 7,
            status: 0,
            children: []
          }
        ]
      }
    ]
  } as ItemsTreeResponse

  return (
    <CardBox sx={{width: '100%'}} style={{padding: 'unset'}}>
      <Box
        sx={{
          ...cardBoxSx,
          display: 'flex',
          gap: '1',
          alignItems: 'center',
          flexWrap: 'wrap'
        }}
      >
        <VerticalNavigationTree
          oldStructure={false}
          isFetching={false}
          isLoading={false}
          tree={tree}
          selectedResourceId={selectedTab ?? NAVIGATION_MENU_ALL_ID_VALUE}
          setSelectedResource={onTabChange}
          selectedDate={formattedDate}
          noDataLabel={noDataLabel}
        />
      </Box>
    </CardBox>
  )
}
